module.exports = __webpack_public_path__ + "08460493e322c0dcbc213df79a8e70f7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-15.png
// module id = 2031
// module chunks = 0